import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellData } from '@ddt-web/data-service';
import { DcrUpdateUtil, Memoize } from '@ddt-web/generic-utils';
import * as _isEmpty from 'lodash/isEmpty';


@Component({
	selector: 'ac-table-cell',
	templateUrl: './table-cell.component.html',
	styleUrls: ['./table-cell.component.scss']
})
export class TableCellComponent {
	@Input() public data: CellData;

	@ViewChild('text', { static: true }) public text: TemplateRef<any>;
	@ViewChild('link', { static: true }) public link: TemplateRef<any>;
	@ViewChild('productLink', { static: true }) public productLink: TemplateRef<any>;
	@ViewChild('iSharesIdeas', { static: true }) public iSharesIdeas: TemplateRef<any>;
	@ViewChild('netPerformanceType', { static: true }) public netPerformanceType: TemplateRef<any>;
	@ViewChild('array', { static: true }) public array: TemplateRef<any>;

	constructor(private contentService: ContentService) { }

	@Memoize()
	public getAdvisoryFeeText(advisoryFee: number): string {
		return DcrUpdateUtil.getAdvisoryFeeText(this.contentService, advisoryFee);
	}

	@Memoize()
	public isEmpty(value: any): boolean {
		return _isEmpty(value);
	}

}
